import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useCallback, useRef } from "react";
import { Link, useParams, NavLink, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";
import { nanoid } from "nanoid";
import { useAppDispatch, useAppSelector } from "../../../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { getAllSupplierInformation } from "../../../redux/handlers/logic/getAllSupplierInformation.handler";
import { defaultOption } from "constants/ui/options";
import { getAllGroupOfSupplier } from "../../../redux/handlers/logic/getAllGroupOfSupplier.handler";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import CurrencyFormat from "react-currency-format";
import DataTable from "@jcognard-actinvision/react-data-table-component";
import Datatablenoresults from "layouts/Datatablenoresults";
import CheckboxTable from "fragments/CheckboxTable";
import DownloadExcel, { autoFitColumns } from "utils/DownloadExcel";
import { useReactToPrint } from "react-to-print";
import PrintIcon from "@mui/icons-material/Print";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { utils, writeFileXLSX } from "xlsx";
import moment from "moment";
import { getAllReportPurchaseProductPoItem } from "../../../redux/handlers/report/getAllReportPurchaseProductPoItem.handler";
import { mappingReportPoItemData } from "utils/HelperReportPoItem";
import { getEmpFullNameTHByEmpData } from "utils/HelperFunction";
import { getUserInfo } from "../../../redux/handlers/auth/getUserInfo.handler";
export function ReportBuyPoItem() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState([]), 2), tabledata = _useState[0], setTabledata = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), optionsGroupOfSuplier = _useState1[0], setOptionsGroupOfSuplier = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), selectedGroupOfSuplierID = _useState2[0], setSelectedGroupOfSuplierID = _useState2[1];
    var _useState3 = _sliced_to_array(useState(defaultOption), 2), groupOfSupplier = _useState3[0], setGroupOfSupplier = _useState3[1];
    var _useState4 = _sliced_to_array(useState(), 2), userInfo = _useState4[0], setUserInfo = _useState4[1];
    var _useState5 = _sliced_to_array(useState({
        startDate: moment().subtract(7, "days").format("DD/MM/YYYY"),
        endDate: moment().format("DD/MM/YYYY")
    }), 2), reportDate = _useState5[0], setReportDate = _useState5[1];
    var loadAllMsts = function() {
        dispatch(getAllGroupOfSupplier());
    };
    var gettableData = function() {
        var queryParams = {
            startDate: reportDate.startDate,
            endDate: reportDate.endDate
        };
        dispatch(getAllReportPurchaseProductPoItem({
            queryParams: queryParams,
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var getAllReportPurchaseProductPoItemReducer = useAppSelector(function(state) {
        return state.getAllReportPurchaseProductPoItemReducer;
    });
    var getUserInfoReducer = useAppSelector(function(state) {
        return state.getUserInfoReducer;
    });
    useEffect(function() {
        loadAllMsts();
        dispatch(getUserInfo({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    // gettableData();
    }, []);
    useEffect(function() {
        setIsLoading(getUserInfoReducer.isFetching);
        if (getUserInfoReducer.data) {
            setUserInfo(getUserInfoReducer.data.data);
        }
    }, [
        getUserInfoReducer
    ]);
    useEffect(function() {
        setIsLoading(getAllReportPurchaseProductPoItemReducer.isFetching);
        if (getAllReportPurchaseProductPoItemReducer.data && !getAllReportPurchaseProductPoItemReducer.isError) {
            var data = getAllReportPurchaseProductPoItemReducer.data.data;
            var mappingData = mappingReportPoItemData(data);
            setTabledata(mappingData);
        }
    }, [
        getAllReportPurchaseProductPoItemReducer
    ]);
    var columns = [
        {
            name: /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: ""
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center",
                        children: "วันที่"
                    })
                ]
            }),
            minWidth: "290px",
            selector: function(row) {
                return row.date;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    children: row.date
                });
            }
        },
        {
            name: /*#__PURE__*/ _jsxs("div", {
                className: "text-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        children: "มูลค่าสินค้าก่อน"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: "ส่วนลด"
                    })
                ]
            }),
            selector: function(row) {
                return row.productPrice;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        " ",
                        /*#__PURE__*/ _jsx(CurrencyFormatC, {
                            val: row.productPrice
                        }),
                        " "
                    ]
                });
            },
            footerContent: function(rows) {
                var total = rows.reduce(function(val, row) {
                    return val + row.productPrice;
                }, 0);
                return /*#__PURE__*/ _jsx(CurrencyFormatC, {
                    val: total
                });
            },
            width: "150px",
            center: true
        },
        {
            name: "ส่วนลด",
            selector: function(row) {
                return row.discount;
            },
            center: true,
            width: "140px",
            footerContent: function(rows) {
                var total = rows.reduce(function(val, row) {
                    return val + row.discount;
                }, 0);
                return /*#__PURE__*/ _jsx(CurrencyFormatC, {
                    val: total
                });
            }
        },
        {
            name: /*#__PURE__*/ _jsxs("div", {
                className: "text-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        children: "ยอดสุทธิ"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: "Inc.Vat"
                    })
                ]
            }),
            selector: function(row) {
                return row.productPriceIncVat;
            },
            width: "140px",
            center: true,
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        " ",
                        /*#__PURE__*/ _jsx(CurrencyFormatC, {
                            val: row.productPriceIncVat
                        }),
                        " "
                    ]
                });
            },
            footerContent: function(rows) {
                var total = rows.reduce(function(val, row) {
                    return val + row.productPriceIncVat;
                }, 0);
                return /*#__PURE__*/ _jsx(CurrencyFormatC, {
                    val: total
                });
            }
        },
        {
            name: /*#__PURE__*/ _jsxs("div", {
                className: "text-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        children: "มูลค่าสินค้า"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: "Ex.Vat"
                    })
                ]
            }),
            selector: function(row) {
                return row.productPriceExVat;
            },
            width: "140px",
            center: true,
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        " ",
                        /*#__PURE__*/ _jsx(CurrencyFormatC, {
                            val: row.productPriceExVat
                        }),
                        " "
                    ]
                });
            },
            footerContent: function(rows) {
                var total = rows.reduce(function(val, row) {
                    return val + row.productPriceExVat;
                }, 0);
                return /*#__PURE__*/ _jsx(CurrencyFormatC, {
                    val: total
                });
            }
        },
        {
            name: "ภาษีมูลค่าเพิ่ม",
            selector: function(row) {
                return row.vat;
            },
            center: true,
            width: "140px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        " ",
                        /*#__PURE__*/ _jsx(CurrencyFormatC, {
                            val: row.vat
                        }),
                        " "
                    ]
                });
            },
            footerContent: function(rows) {
                var total = rows.reduce(function(val, row) {
                    return val + row.vat;
                }, 0);
                return /*#__PURE__*/ _jsx(CurrencyFormatC, {
                    val: total
                });
            }
        },
        {
            name: "จำนวนสินค้า",
            selector: function(row) {
                return row.product;
            },
            center: true,
            width: "140px",
            footerContent: function(rows) {
                var total = rows.reduce(function(val, row) {
                    return val + row.product;
                }, 0);
                return total;
            }
        },
        {
            name: "จำนวนบิล",
            selector: function(row) {
                return row.bill;
            },
            center: true,
            width: "140px",
            footerContent: function(rows) {
                var total = rows.reduce(function(val, row) {
                    return val + row.bill;
                }, 0);
                return total;
            }
        },
        {
            name: /*#__PURE__*/ _jsxs("div", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-[#DC0000] h-[40px] pt-2 ml-[110px]",
                        style: {
                            position: "absolute",
                            whiteSpace: "nowrap",
                            zIndex: 999
                        },
                        children: "ส่งคืนสินค้า"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-[#DC0000]  h-[40px] border-b-[1px] border-[#E5E5E5]"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center text-[#DC0000] pt-2 pb-2 border-r-[1px] border-[#E5E5E5] ",
                        children: "จำนวนบิล"
                    })
                ]
            }),
            selector: function(row) {
                return row.productReturnBill;
            },
            center: true,
            width: "140px",
            footerContent: function(rows) {
                var total = rows.reduce(function(val, row) {
                    return val + row.productReturnBill;
                }, 0);
                return total;
            }
        },
        {
            name: /*#__PURE__*/ _jsxs("div", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-[#DC0000] h-[40px] border-b-[1px] border-[#E5E5E5]"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center text-[#DC0000]  pt-2 pb-2",
                        children: "มูลค่าสินค้า"
                    })
                ]
            }),
            selector: function(row) {
                return row.productReturnPrice;
            },
            center: true,
            width: "130px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        " ",
                        /*#__PURE__*/ _jsx(CurrencyFormatC, {
                            val: row.productReturnPrice
                        }),
                        " "
                    ]
                });
            },
            footerContent: function(rows) {
                var total = rows.reduce(function(val, row) {
                    return val + row.productReturnPrice;
                }, 0);
                return /*#__PURE__*/ _jsx(CurrencyFormatC, {
                    val: total
                });
            }
        }
    ];
    var _useState6 = _sliced_to_array(useState(""), 2), filterText = _useState6[0], setFilterText = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), filteredItems = _useState7[0], setFilteredItems = _useState7[1];
    var CurrencyFormatC = function(param) {
        var val = param.val;
        return /*#__PURE__*/ _jsx(CurrencyFormat, {
            value: val,
            decimalScale: 2,
            fixedDecimalScale: true,
            displayType: "text",
            thousandSeparator: true,
            prefix: ""
        });
    };
    var contentRef = useRef(null);
    var handlePrint = useReactToPrint({
        contentRef: contentRef
    });
    var download = function(data, filename) {
        if (data && data.length > 0) {
            var ws = utils.json_to_sheet(data, {
                origin: "A6"
            });
            ws["A1"] = {
                v: "รายงานการซื้อตามสินค้าจากใบสั่งซื้อ",
                t: "s"
            };
            ws["!merges"] = [
                {
                    s: {
                        r: 0,
                        c: 0
                    },
                    e: {
                        r: 0,
                        c: 3
                    }
                }
            ];
            // Add the second row with specific cells populated
            ws["A2"] = {
                v: "จำนวนรายการ",
                t: "s"
            };
            ws["B2"] = {
                v: "".concat(data.length, " รายการ"),
                t: "s"
            };
            ws["E2"] = {
                v: "ช่วงเวลาข้อมูล",
                t: "s"
            };
            ws["F2"] = {
                v: "".concat(moment(reportDate.startDate).format("DD/MM/YYYY"), " - ").concat(moment(reportDate.endDate).format("DD/MM/YYYY")),
                t: "s"
            };
            ws["A3"] = {
                v: "ผู้จัดทำ",
                t: "s"
            };
            ws["B3"] = {
                v: getEmpFullNameTHByEmpData(userInfo === null || userInfo === void 0 ? void 0 : userInfo.dimNewAlldernowEmp),
                t: "s"
            };
            ws["E3"] = {
                v: "เวลาดึงข้อมูล",
                t: "s"
            };
            ws["F3"] = {
                v: moment().format("DD/MM/YYYY - hh:mm A"),
                t: "s"
            };
            // Compute sum total for the footer
            var totalRow = data.length + 7;
            var footerData = [
                {
                    G: "รวมทั้งหมด",
                    H: null,
                    I: null,
                    J: {
                        f: "SUM(J7:J".concat(totalRow - 1, ")")
                    },
                    K: null,
                    L: null,
                    M: null,
                    N: null,
                    O: {
                        f: "SUM(O7:O".concat(totalRow - 1, ")")
                    },
                    P: {
                        f: "SUM(P7:P".concat(totalRow - 1, ")")
                    },
                    Q: {
                        f: "SUM(Q7:Q".concat(totalRow - 1, ")")
                    }
                }
            ];
            utils.sheet_add_json(ws, footerData, {
                skipHeader: true,
                origin: "G".concat(totalRow)
            });
            // Adjust column widths for better readability
            ws["!cols"] = autoFitColumns(data, ws);
            var wb = utils.book_new();
            utils.book_append_sheet(wb, ws, filename);
            // Write the workbook to file
            writeFileXLSX(wb, filename + ".xlsx");
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx("nav", {
                    "aria-label": "breadcrumb",
                    className: "mt-2 mb-4",
                    children: /*#__PURE__*/ _jsxs("ol", {
                        className: "breadcrumb fs-16 ps-0",
                        children: [
                            /*#__PURE__*/ _jsx("li", {
                                className: "breadcrumb-item ",
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: "#",
                                    className: "tc-7  text-decoration-none",
                                    children: "รายงาน"
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                className: "breadcrumb-item ",
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: "#",
                                    className: "tc-7  text-decoration-none",
                                    children: "รายงานการซื้อ"
                                })
                            }),
                            /*#__PURE__*/ _jsxs("li", {
                                className: "breadcrumb-item active tc-1 ",
                                "aria-current": "page",
                                children: [
                                    " ",
                                    "รายงานมูลค่าการซื้อแยกรายสินค้า",
                                    " "
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "card card-st-2 mb-4",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "card-body px-0 pt-4 pb-0",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "mb-2 text-[#4C4E64]/[0.87] font-semibold text-lg px-4",
                            children: "ตัวเลือก"
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex align-items-center px-4 mb-0 flex-wrap",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "w-[300px] mr-4",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-3 form-st-3 pb-1",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "เลือกช่วงวันที่ "
                                            }),
                                            /*#__PURE__*/ _jsx(DateRangePicker, {
                                                initialSettings: {
                                                    startDate: moment().subtract(7, "days").format("DD/MM/YYYY"),
                                                    endDate: moment().format("DD/MM/YYYY"),
                                                    locale: {
                                                        format: "DD/MM/YYYY"
                                                    }
                                                },
                                                onEvent: function(e, picker) {
                                                    setReportDate({
                                                        startDate: picker.startDate.format("YYYY-MM-DD"),
                                                        endDate: picker.endDate.format("YYYY-MM-DD")
                                                    });
                                                },
                                                children: /*#__PURE__*/ _jsx("input", {
                                                    type: "text",
                                                    className: "form-control  h-[44px]"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    onClick: function() {
                                        return gettableData();
                                    },
                                    className: "btn btn btn-st-7 mb-2 mr-4 px-4 ",
                                    children: "execute"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    className: "btn btn btn-st-8 mb-2 px-4 ",
                                    onClick: function() {
                                        return download(tabledata, "report_by_po_item_".concat(moment().format("YYYY_MM_DD")));
                                    },
                                    disabled: !(tabledata && tabledata.length > 0),
                                    children: !(tabledata && tabledata.length > 0) ? "ไม่มีข้อมูล" : "download"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
var customStyles = {
    rows: {
        style: {
            minHeight: "52px",
            border: 0
        }
    },
    headCells: {
        style: {
            paddingLeft: "15px",
            paddingRight: "15px",
            color: "rgba(76, 78, 100, 0.87)",
            fontFamily: "Sarabun",
            fontSize: "16px",
            background: " #F5F5F7",
            paddingTop: "15px",
            paddingBottom: "15px",
            borderTop: "1px solid #E5E5E5",
            borderRight: "1px solid #E5E5E5"
        }
    },
    cells: {
        style: {
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingTop: "10px",
            paddingBottom: "10px",
            color: "rgba(76, 78, 100, 0.87)",
            fontFamily: "Sarabun",
            fontSize: "16px",
            fontWeight: "300"
        }
    }
};
var paginationComponentOptions = {
    rowsPerPageText: "จำนวนรายการต่อหน้า",
    rangeSeparatorText: "of",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos"
};
